import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { styles } from "../components/CsStyles";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };

    // Title
    if (this.props.setTitle != null) this.props.setTitle("Home");
  }

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <CssBaseline />

        <div className={classes.root}>
          <main className={classes.content}>
            <div className={classes.appBarSpacer} />

            <Grid container spacing={3}>
              <Grid item xs={2}></Grid>

              <Grid item xs={1}>
                <img
                  className={classes.fullImage}
                  src="logobw.png"
                  alt="Boxoffice"
                  width="20%"
                ></img>
              </Grid>

              <Grid item xs={9}>
                {" "}
              </Grid>

              <Grid item xs={12}>
                {" "}
              </Grid>

              <Grid item xs={2}>
                {" "}
              </Grid>

              <Grid item xs={4}>
                <div className={classes.paperVert}>
                  <Typography variant="h3" gutterBottom>
                    <b>Scoreboard V2.0</b>
                  </Typography>
                  <Typography variant="subtitle1">
                    Find movies. View the automater status. Look up houses.
                    Everything you need to check the status of the CinemaSource
                    database, updated in near-realtime. Now with Metabase
                    integration.
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={6}>
                <img
                  className={classes.fullImage}
                  src="Homeplash1.png"
                  alt="Boxoffice"
                ></img>
              </Grid>
            </Grid>
          </main>
        </div>
      </React.Fragment>
    );
  }
}

Home.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Home);
